import { Loader2Icon } from 'lucide-react'

/** Affiché pendant la résolution d'une route (revalidation de session incluse). */
export function RoutePending() {
  return (
    <div
      className="flex min-h-[50dvh] items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <Loader2Icon className="size-5 animate-spin text-muted-foreground" />
      <span className="sr-only">Chargement…</span>
    </div>
  )
}
